"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledQuickFilter = exports.StyledLabel = exports.StyledImage = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _picture = require("../../fuse-picture/src/picture");
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = require("../../fuse-typography-element/src/typography");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var SquircleSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M50 25c0 18.41-6.59 25-25 25S0 43.41 0 25 6.59 0 25 0s25 6.59 25 25Z"/></svg>';
var StyledQuickFilter = exports.StyledQuickFilter = _styledComponents["default"].a.attrs({
  className: 'fuse-quick-filter'
}).withConfig({
  displayName: "styled-quick-filter__StyledQuickFilter",
  componentId: "sc-m3ib2q-0"
})(["display:flex;flex-direction:column;justify-content:flex-start;gap:var(--spacing-global-space3);text-decoration:none;cursor:pointer;&:focus-visible{outline:var(--border-width-s) solid var(--color-functional-focus);}&:focus:not(:focus-visible){outline:none;}", ";"], function () {
  var textDecorationUnderline = function textDecorationUnderline(colour) {
    return "\n\t\t\ttext-decoration-line: underline;\n\t\t\ttext-decoration-color: ".concat(colour, ";\n\t\t\ttext-decoration-style: solid;\n\t\t\ttext-decoration-thickness: 1px;\n\t\t");
  };
  return "\n\t\t\t&:hover .fuse-quick-filter__label,\n\t\t\t&:focus .fuse-quick-filter__label {\n\t\t\t\tcolor: var(--color-brand-dark);\n\t\t\t\t".concat(textDecorationUnderline("var(--color-brand-dark)"), "\n\t\t\t}\n\n\t\t\t&:active .fuse-quick-filter__label {\n\t\t\t\tcolor: var(--color-global-black);\n\t\t\t\t").concat(textDecorationUnderline("var(--color-global-black)"), "\n\t\t\t}\n\t\t");
});
var StyledImage = exports.StyledImage = (0, _styledComponents["default"])(_picture.Picture).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'imageLink';
  }
}).attrs({
  className: 'fuse-quick-filter__image',
  'data-testid': 'fuse-quick-filter-image-test-id'
}).withConfig({
  displayName: "styled-quick-filter__StyledImage",
  componentId: "sc-m3ib2q-1"
})(["margin:0;@media screen and (min-width:", "){margin:var(--spacing-global-space1) var(--spacing-global-space1) 0 var(--spacing-global-space1);}& .fuse-picture__img{aspect-ratio:1/1;object-fit:cover;mask:url('data:image/svg+xml, ", "') center/cover no-repeat;-webkit-mask:url('data:image/svg+xml, ", "') center/cover no-repeat;width:100%;}"], _grid.gridConfig.l.minWidth, encodeURIComponent(SquircleSVG), encodeURIComponent(SquircleSVG));
var StyledLabel = exports.StyledLabel = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-quick-filter__label',
  'data-testid': 'fuse-quick-filter-label-test-id',
  size: '1',
  type: 'paragraph'
}).withConfig({
  displayName: "styled-quick-filter__StyledLabel",
  componentId: "sc-m3ib2q-2"
})(["color:var(--color-global-grey1000);text-align:center;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-height:var(--spacing-global-space6);max-height:var(--spacing-global-space9);margin-bottom:0;"]);